import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { designTokens, baseColors } from "theme";

export const styles = (theme: Theme) => {
	return {
		card: {
			backgroundColor: designTokens.colors.white,
			border: `1px solid ${designTokens.colors.borderCard}`,
			borderRadius: 8,
			overflow: "hidden",
			width: "100%",
			boxSizing: "border-box",
			// MUI draws a divider line above every accordion; this one stands alone as a card.
			"&::before": {
				display: "none",
			},
		},
		summary: {
			backgroundColor: baseColors.orange25,
			padding: theme.spacing(0, 3),
		},
		summaryContent: {
			display: "flex",
			alignItems: "center",
			gap: 8,
		},
		icon: {
			fontSize: 20,
			color: designTokens.colors.brandOrange,
		},
		title: {
			fontSize: 16,
			fontWeight: 700,
			color: baseColors.darkCharcoal,
		},
		chevron: {
			fontSize: 20,
			color: designTokens.colors.iconNeutral,
		},
		details: {
			display: "flex",
			flexDirection: "column",
			padding: 0,
		},
		// The table runs to the card's edges, so row borders do too; only the outer cells are inset.
		table: {
			"& .MuiTableCell-root": {
				borderRight: "none",
			},
			"& .MuiTableCell-root:first-of-type": {
				paddingLeft: theme.spacing(2),
			},
			"& .MuiTableCell-root:last-of-type": {
				paddingRight: theme.spacing(2),
			},
			"& .MuiCheckbox-root.Mui-checked, & .MuiCheckbox-root.MuiCheckbox-indeterminate": {
				color: designTokens.colors.brandOrange,
			},
		},
		field: {
			fontWeight: 600,
			color: baseColors.darkCharcoal,
		},
		current: {
			color: designTokens.colors.grayDark,
		},
		suggested: {
			fontWeight: 600,
			color: baseColors.darkCharcoal,
		},
		conversation: {
			display: "flex",
			flexDirection: "column",
			alignItems: "flex-start",
			gap: 4,
		},
		viewConversation: {
			fontSize: 13,
			color: designTokens.colors.linkPrimary,
		},
		date: {
			whiteSpace: "nowrap",
			color: designTokens.colors.grayDark,
		},
		footer: {
			display: "flex",
			alignItems: "center",
			gap: theme.spacing(1),
			padding: theme.spacing(2),
		},
		selectedCount: {
			marginRight: "auto",
			fontSize: 14,
			color: designTokens.colors.grayDark,
		},
	} satisfies Record<string, CSSObject>;
};
